import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { Link } from 'react-router'
import { logout } from '../../../actions/auth'

// import routes
import routes from '../../../routes'

// import styles
import './menu.scss'

// Utils
import { translation } from '../../../utils/helpers'
import { hasAccess, isLoginFromShop, hasDepartmentType, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../utils/auth'

import Icon from '../../elements/icon'

class Menu extends Component {

  constructor (props) {
    super(props)
    this.state = {
      routes: []
    }
    this.openMenu = this.openMenu.bind(this)
    this.renderRoute = this.renderRoute.bind(this)
    this.support = this.support.bind(this)
  }

  componentDidMount () {
    this.makeMenuItems()
  }

  componentWillReceiveProps () {
    this.makeMenuItems()  // Recreate menu items to ensure links are valid for the current user (ex. if user switched login from one customer to another...)
  }

  makeMenuItems () {
    let finalRoutes = []
    routes(null).map((outerRoute) => {
      if (outerRoute.path === '/') {
        outerRoute.childRoutes.map((childRoute) => {
          if (typeof childRoute.menu !== 'undefined') {
            let link = childRoute.path
            if (typeof childRoute.menu.parser !== 'undefined') {
              link = childRoute.menu.parser(this.props.auth.user, childRoute.path)
            }
            let title = childRoute.menu.title
            if (typeof childRoute.menu.title === 'function') {
              title = childRoute.menu.title(this.props.auth.departmentType)
            }
            if (link !== null) {
              finalRoutes.push({
                order: childRoute.menu.order || 100,
                title: title,
                icon: childRoute.menu.icon,
                access: childRoute.menu.access || childRoute.access,
                link: link,
                isAvailableFree: childRoute.isAvailableFree,
                checkAuth: childRoute.checkAuth,
                hasValidShop: childRoute.hasValidShop,
                permissionId: childRoute.permissionId,
                exclPermissionId: childRoute.exclPermissionId,
                onlyDev: childRoute.onlyDev,
                ValidShopCheck: childRoute.ValidShopCheck,
                subscriptionValue: childRoute.subscriptionValue || -10,
                maxSubscriptionValue: childRoute.maxSubscriptionValue,
                checkPartnerSubscription: childRoute.checkPartnerSubscription === true
              })
            }
          }
        })
      }
    })
    finalRoutes = finalRoutes.sort((a, b) => {
      return a.order - b.order
    })
    this.setState({
      routes: finalRoutes
    })
  }

  openMenu () {
    this.props.openMenu()
  }

  renderRoute (item, key) {
    let UserType = this.props.auth.user.UserType
    if (isLoginFromShop(this.props.auth.inactiveUsers)) {
      // if you logged in as a shop, you shouldn't be able to get an employees rights
      UserType = 5
    }
    // Check free permissions
    let permissionId = item.permissionId !== undefined && item.permissionId !== null ? item.permissionId : 0
    // if (!hasPermission(this.props.auth, permissionId, item.isAvailableFree)) return null
    if (!(hasSubscriptionPermission(this.props.auth, item.subscriptionValue, permissionId) || item.checkPartnerSubscription && hasPartnerSubscriptionPermission(this.props.auth, item.subscriptionValue))) return null
    if (item.exclPermissionId !== undefined) {
      // let excludeByPermission = hasSubscriptionPermission(this.props.auth, item.subscriptionValue, item.exclPermissionId)
      if (hasSubscriptionPermission(this.props.auth, item.subscriptionValue, item.exclPermissionId)) return null
    }
    if (typeof item.checkAuth === 'function' && !item.checkAuth(this.props.auth)) return null
    if (item.maxSubscriptionValue !== undefined && hasSubscriptionPermission(this.props.auth, item.maxSubscriptionValue)) return null
    if (!hasAccess(item.access, UserType)) return null
    if (process.env.NODE_ENV !== 'dev' && item.onlyDev) return null
    let hasValidShops = item.hasValidShop
    let isValidShop = true
    if (hasValidShops !== undefined && hasValidShops.length > 0) {
      isValidShop = hasDepartmentType(this.props.auth, hasValidShops, UserType, item.ValidShopCheck)
    }
    if (isValidShop !== true) {
      return null
    }
    // if (item.link === '/CarRentals/Overview' && this.props.auth.allowCarRentalOverview !== true) return null
    // if (item.link === '/CarRental' && this.props.auth.allowCarRentalOverview === true) return null
    // if (item.link === '/qualitychecksettings' && this.props.auth.departmentType === 1) return null
    if (item.link === '/insurancecompanylist' && (this.props.auth.departmentType === 0 || this.props.auth.permissions.ChainAssessmentSystem === 0)) return null
    if (item.link === '/CarRental' && this.props.auth.departmentType === 0) return null
    if (item.link === '/CarRentals/Overview' && this.props.auth.departmentType === 0) return null
    if (item.link === '/addresses' && this.props.auth.departmentType === 0 && hasAccess([3, 5, 7], UserType)) return null
    if (item.link === '/punchclock' && this.props.auth.shopPunchClockActive !== true) return null
    if (item.link === '/forsilist' && this.props.auth.permissions.ChainAssessmentSystem !== 1) return null

    return (
      <Link className='menu-line' key={key} onClick={this.openMenu} to={item.link}>
        <Icon size='m' icon={item.icon} injectSvg /> <span>{translation(item.title)}</span>
      </Link>
    )
  }

  support () {
    if (this.props.auth.user.ChainId === 2 || this.props.auth.user.ChainId === '2' || this.props.auth.user.ChainName === 'LakExperten') {
      return (
        <li className='support'>
          <Link target='_blank' to={'https://898.tv/apromaslakexpertensupport'} >
            <img src={'/images/Q-grey.svg'} /> {translation('Fjernsupport')}
          </Link>
          <p>{'70 70 72 85'}</p>
        </li>
      )
    }
  }

  render () {
    return (
      <div className='main__menu'>
        <div className='icon' onClick={this.openMenu}><i className='fa fa-bars' /></div>
        <div className={'menu__wrapper ' + (this.props.menuOpen ? 'open' : 'closed')}>
          <ul>
            {this.state.routes.map(this.renderRoute)}
            {1 === 2 && this.support()}
          </ul>
        </div>
      </div>
    )
  }

}

Menu.propTypes = {
  logout: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { logout })(Menu)



// WEBPACK FOOTER //
// ./src/app/shared/components/Menu/index.js